// extracted by mini-css-extract-plugin
module.exports = {"root":"card_root__exPmw","disablePadding":"card_disablePadding__0FM8n","clickable":"card_clickable__H_5P4","highlight":"card_highlight__s3Ww_","disabled":"card_disabled__fwaNV"};